<div class="image-container">
  <img src="assets/navimage.png" width="100%" alt="Gallery Banner">

  <div class="image-text">
    <p>Gallery</p>
  </div>
</div>

<div class="gallery-spacer"></div>

<div class="container-fluid gallery-page" *ngIf="pageData$ | async">

  <mat-tab-group class="gallery-tabs">

    <!-- CULTURAL -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>group</mat-icon>
        <span>Cultural Activities</span>
        <span class="count">{{culturalImages.length}}</span>
      </ng-template>

      <div class="gallery-grid">
        <div
          class="gallery-card"
          *ngFor="let img of culturalImages;let i=index"
          (click)="openViewer(culturalImages,i)"
        >
          <img [src]="img" alt="Cultural Activity" loading="lazy">

          <div class="gallery-overlay">
            <mat-icon>zoom_in</mat-icon>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- SPORTS -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>sports_rugby</mat-icon>
        <span>Sports</span>
        <span class="count">{{sportsImages.length}}</span>
      </ng-template>

      <div class="gallery-grid">
        <div
          class="gallery-card"
          *ngFor="let img of sportsImages;let i=index"
          (click)="openViewer(sportsImages,i)"
        >
          <img [src]="img" alt="Sports" loading="lazy">

          <div class="gallery-overlay">
            <mat-icon>zoom_in</mat-icon>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- CELEBRATION -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>celebrations</mat-icon>
        <span>School Celebration</span>
        <span class="count">{{celebrationImages.length}}</span>
      </ng-template>

      <div class="gallery-grid">
        <div
          class="gallery-card"
          *ngFor="let img of celebrationImages;let i=index"
          (click)="openViewer(celebrationImages,i)"
        >
          <img [src]="img" alt="School Celebration" loading="lazy">

          <div class="gallery-overlay">
            <mat-icon>zoom_in</mat-icon>
          </div>
        </div>
      </div>
    </mat-tab>

  </mat-tab-group>

</div>